import React from "react";
import PropTypes from "prop-types";

/**
 * Componente VerticalTimelineWrapper
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do wrapper da linha do tempo vertical.
 * @returns {ReactElement} O elemento React renderizado que representa o wrapper da linha do tempo vertical.
 */
function VerticalTimelineWrapper({ children }) {
  return (
    <ul className="verti-timeline list-unstyled m-0" id="list-notifications">
      {children}
    </ul>
  );
}

VerticalTimelineWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VerticalTimelineWrapper;
